import { VenueBasedEventSerializer } from "@app-contexts/dashboard/features/events/data/types/events";
import { PUBLIC_ROUTES } from "@app-contexts/public/constants/public-routes";
import { PublicBaseEventSerializer } from "@shared/modules/events/types/public";
import { SeatingEventPropertyMap } from "@shared/modules/seating/types/seating-property-types";

type EventWithSlug = Pick<
  | PublicBaseEventSerializer
  | SeatingEventPropertyMap
  | VenueBasedEventSerializer,
  "slug"
>;

/**
 * Hook to get event page paths
 *
 * Uses PUBLIC_ROUTES for URL generation. The page component decides
 * whether to render legacy or branded content based on waffle flag.
 *
 * Note: Always generates from slug rather than using frontend_details_url
 * because that field can contain full URLs (including external links)
 * which break Next.js client-side navigation.
 */
export const useGetEventPath = () => {
  const getEventPath = (event: EventWithSlug | null | undefined): string => {
    if (!event?.slug) {
      return "/";
    }

    return PUBLIC_ROUTES.EVENTS.detail(event.slug);
  };

  return { getEventPath };
};
